var m = Object.defineProperty;
var p = (l, e, t) => e in l ? m(l, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : l[e] = t;
var i = (l, e, t) => (p(l, typeof e != "symbol" ? e + "" : e, t), t);
class g {
  constructor() {
    i(this, "collection");
    this.collection = /* @__PURE__ */ new Map();
  }
  remove(e) {
    for (const [, t] of this.collection) {
      const n = t.indexOf(e);
      n !== -1 && t.splice(n, 1);
    }
  }
  search(e) {
    const t = [], n = e.length, s = /* @__PURE__ */ new Map();
    for (let o = 0; o < n; o++) {
      const r = e[o], c = this.get(r), h = c.length;
      for (let a = 0; a < h; a++) {
        const u = c[a];
        this.relevance(r, u), s.has(u) || (t.push(u), s.set(u, !0));
      }
    }
    return s.clear(), this.sort(t);
  }
  sort(e) {
    return e;
  }
  get length() {
    return this.collection.size;
  }
  get(e) {
    if (this.collection.has(e)) {
      const t = this.collection.get(e);
      if (t && t.length > 0)
        return t;
      this.collection.delete(e);
    }
    return [];
  }
}
class k extends g {
  constructor() {
    super();
    i(this, "k1", 1.3);
    i(this, "b", 0.75);
    i(this, "average", 0);
    i(this, "totalTerms", 0);
    i(this, "totalDocuments", 0);
    i(this, "term");
    i(this, "score");
    i(this, "frequency");
    this.term = /* @__PURE__ */ new Map(), this.score = /* @__PURE__ */ new Map(), this.frequency = /* @__PURE__ */ new Map();
  }
  insert(t, n) {
    const s = n.length;
    if (s === 0)
      return;
    this.totalDocuments = this.totalDocuments + 1, this.totalTerms = this.totalTerms + n.length, this.average = this.totalTerms / this.totalDocuments;
    const o = [];
    for (let r = 0; r < s; r++) {
      const c = n[r];
      this.collection.has(c) || this.collection.set(c, []);
      const h = this.collection.get(c);
      h && h.indexOf(t) === -1 && h.push(t), this.frequency.has(t) || this.frequency.set(t, /* @__PURE__ */ new Map());
      const a = this.frequency.get(t);
      if (a) {
        a.has(c) || a.set(c, {
          count: 0,
          total: s
        });
        const f = a.get(c);
        f && (f.count = f.count + 1);
      }
      this.term.has(c) || this.term.set(c, {
        idf: 0,
        count: 0
      });
      const u = this.term.get(c);
      u && o.indexOf(c) === -1 && (o.push(c), u.count = u.count + 1);
    }
    this.calculateInverseDocumentFrequency();
  }
  relevance(t, n) {
    this.score.has(n) || this.score.set(n, 0);
    const o = this.term.get(t).idf, c = this.frequency.get(n).get(t), h = c.count, a = h * (this.k1 + 1), u = h + this.k1 * (1 - this.b + this.b * c.total / this.average), f = o * a / u;
    this.score.set(n, this.score.get(n) + f);
  }
  sort(t) {
    return t.sort((n, s) => this.score.get(s) - this.score.get(n)), this.reset(), t;
  }
  reset() {
    this.score.clear();
  }
  calculateInverseDocumentFrequency() {
    for (const [, t] of this.term) {
      const n = this.totalDocuments - t.count + 0.5, s = t.count + 0.5;
      t.idf = Math.max(Math.log10(n / s), 0.01);
    }
  }
}
class z {
  tokenize(e) {
    const t = [], n = e.split(/[^a-zA-ZÀ-ÿ0-9_\-']+/g), s = n.length;
    for (let o = 0; o < s; o++) {
      const r = n[o];
      r && t.push(r);
    }
    return t;
  }
}
class d {
  constructor(e, t) {
    i(this, "tokenizer");
    i(this, "stopWord");
    this.tokenizer = e, this.stopWord = t;
  }
  tokenize(e) {
    const t = [], n = this.tokenizer.tokenize(e), s = n.length;
    for (let o = 0; o < s; o++) {
      const r = n[o];
      this.stopWord[r.toLowerCase()] || t.push(r);
    }
    return t;
  }
}
class x {
  constructor(e) {
    i(this, "tokenizer");
    this.tokenizer = e;
  }
  tokenize(e) {
    const t = [], n = this.tokenizer.tokenize(e), s = n.length;
    for (let o = 0; o < s; o++) {
      const r = n[o];
      t.push(r.normalize("NFD").replace(/\p{Diacritic}/gu, ""));
    }
    return t;
  }
}
class y {
  constructor(e) {
    i(this, "tokenizer");
    this.tokenizer = e;
  }
  tokenize(e) {
    const t = [], n = this.tokenizer.tokenize(e), s = n.length;
    for (let o = 0; o < s; o++) {
      const r = n[o];
      t.push(r.toLocaleLowerCase());
    }
    return t;
  }
}
class w {
  static init(e, t, n) {
    let s = new z();
    return e || (s = new y(s)), t && (s = new x(s)), n && (s = new d(s, n)), s;
  }
}
class v {
  apply(e) {
    return e;
  }
}
class D {
  apply(e) {
    const t = [], n = e.length;
    for (let s = 0; s < n; s++) {
      const o = e[s], r = o.length;
      for (let c = 1; c <= r; c++)
        t.push(o.substring(0, c));
    }
    return t;
  }
}
class M extends g {
  constructor() {
    super();
  }
  insert(e, t) {
    const n = t.length, s = /* @__PURE__ */ new Map();
    for (let o = 0; o < n; o++) {
      const r = t[o];
      this.collection.has(r) || this.collection.set(r, []), s.has(r) || s.set(r, /* @__PURE__ */ new Map());
      const c = this.collection.get(r);
      c && !s.get(r).has(e) && (c.push(e), s.get(r).set(e, !0));
    }
  }
  relevance() {
  }
}
class S {
  constructor(e = {}) {
    i(this, "document");
    i(this, "strategy");
    i(this, "tokenizer");
    const {
      caseSensitive: t = !1,
      exactWordStrategy: n = !1,
      ignoreAccent: s = !0,
      stopWord: o = null,
      unorderedDocument: r = !0
    } = e;
    this.tokenizer = w.init(t, s, o), this.document = r ? new M() : new k(), this.strategy = n ? new v() : new D();
  }
  index(e, t) {
    this.document.insert(`${e}`, this.strategy.apply(this.prepare(t)));
  }
  search(e) {
    return this.document.search(this.tokenizer.tokenize(e));
  }
  remove(e) {
    this.document.remove(`${e}`);
  }
  isEmpty() {
    return this.document.length === 0;
  }
  prepare(e) {
    let t = [];
    if (!e)
      return t;
    if (Array.isArray(e)) {
      const n = e.length;
      for (let s = 0; s < n; s++) {
        const o = this.prepare(e[s]), r = o.length;
        for (let c = 0; c < r; c++)
          t.push(o[c]);
      }
    } else if (typeof e == "object") {
      const n = Object.keys(e), s = n.length;
      for (let o = 0; o < s; o++) {
        const r = n[o], c = this.prepare(e[r]), h = c.length;
        for (let a = 0; a < h; a++)
          t.push(c[a]);
      }
    } else
      t = this.tokenizer.tokenize(String(e));
    return t;
  }
}
export {
  S as Search
};
